import React from 'react';

import styles from './coatings.scss';

/**
 * default class for coating popup
 * @returns {ReactNode} Rendered react component
 * @constructor
 */
export const Coatings = () => (
    <div className={styles.coating}>
        <div className={styles.column}>
            <h2 className={styles.title}>UV</h2>
            <p className={styles.text}>
                Provides superior protection from <br />
                UV (ultraviolet) light, which <br />
                damages the retina and is a source <br />
                for many eye ailments. The UV <br />
                coating shields your eyes from the <br />
                sun&#8216;s harmful rays without altering <br />
                the appearance of the lens.
            </p>
        </div>
        <div className={styles.column}>
            <h2 className={styles.title}>Anti-Reflective</h2>
            <p className={styles.text}>
                Anti-reflective coating eliminates the <br />
                annoying reflections of light from the <br />
                surface of your lens, providing <br />
                sharper vision and a clearer lens <br />
                It&#8216;s perfect for everyday use, including <br />
                sitting in front of your computer and nighttime driving.
            </p>
        </div>
    </div>
);
